"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Calculates the streak length by counting the number
 * of consecutive days for which a streak day was awarded,
 * in recent days. If all of the recent days were streak
 * days, returns the long term streak value.
 *
 * @param {array} recentDays      Array of boolean values indicating whether that day was a streak day.
 * @param {number} longTermStreak The user's crruentStreak value.
 *
 * @returns {number} Streak length
 */
var calculateStreakLength = function (recentDays, longTermStreak) {
    var days = __spread(recentDays).reverse();
    var total = days.reduce(function (value, day, index) {
        // If day is a streak day, and the streak has not ended
        // increment the total.
        if (day && !value.ended) {
            return {
                ended: false,
                total: day === 1 ? value.total + 1 : value.total,
            };
        }
        // If day is today, we ignore a false value
        // because user can still continue the streak
        if (!day && index === 0) {
            return {
                ended: false,
                total: 0,
            };
        }
        // Day is not a streak day (or streak was broken earlier).
        // Unless we count today as achieved and curren day is today,
        // mark the streak as ended and don't increment the total.
        return {
            ended: true,
            total: value.total,
        };
    }, { total: 0, ended: false }).total;
    // If the total is equal to the number of recent days the
    // streak could be longer than the number of recent days
    // displayed. In that case, return the longTermStreak value.
    if (total === recentDays.length) {
        total = longTermStreak;
    }
    return total;
};
exports.default = calculateStreakLength;
//# sourceMappingURL=calculateStreakLength.js.map